import { DocumentPage } from './DocumentPage';
import { withLayoutOnlyHeader } from '../../layout/Layout';

export default withLayoutOnlyHeader(DocumentPage);